import { render, staticRenderFns } from "./ClinicalTracking.vue?vue&type=template&id=4a8dd4c2"
import script from "./ClinicalTracking.vue?vue&type=script&lang=js"
export * from "./ClinicalTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports